import styled from '@emotion/styled';
import type { EmotionScore, IconSize } from './settings';
import { getIconColor, iconSizeMap, iconBaseStyles } from './settings';

const Svg = styled.svg`
  ${iconBaseStyles}
`;

interface BuddyIconProps {
  score: EmotionScore;
  size: IconSize;
}

export function BuddyIcon(props: BuddyIconProps): JSX.Element {
  const { score, size } = props;
  const px = iconSizeMap[size];
  const fill = getIconColor(score);
  const stroke = 'none';

  return (
    <Svg
      aria-hidden
      width={px}
      height={px}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {(() => {
        switch (score) {
          case 0:
            return (
              <g clipPath="url(#clip0)">
                <path
                  style={{ stroke, fill, fillOpacity: 0.89 }}
                  d="M14.5 1H.5a.5.5 0 00-.35.85L2 3.71v8.79A1.5 1.5 0 003.5 14h11a1.5 1.5 0 001.5-1.5v-10A1.5 1.5 0 0014.5 1z"
                />
                <path
                  style={{ stroke, fill: '#fff' }}
                  d="M9 9a2 2 0 012 1.6.51.51 0 101-.2 3.06 3.06 0 00-5.98 0 .5.5 0 00.98.2A2 2 0 019 9zM6.5 7.25a.75.75 0 100-1.5.75.75 0 000 1.5zM11.5 7.25a.75.75 0 100-1.5.75.75 0 000 1.5zM12.95 3.28a.5.5 0 00-.67-.23l-2 1a.5.5 0 10.44.9l2-1a.5.5 0 00.23-.67zM7.5 5a.5.5 0 00.22-.95l-2-1a.5.5 0 10-.44.9l2 1A.5.5 0 007.5 5z"
                />
              </g>
            );
          case 1:
            return (
              <g clipPath="url(#clip0)">
                <path
                  style={{ stroke, fill, fillOpacity: 0.89 }}
                  d="M14.5 1H.5a.5.5 0 00-.35.85L2 3.71v8.79A1.5 1.5 0 003.5 14h11a1.5 1.5 0 001.5-1.5v-10A1.5 1.5 0 0014.5 1z"
                />
                <path
                  style={{ stroke, fill: '#fff' }}
                  d="M9 9a2 2 0 00-2 1.6.51.51 0 01-1-.2A3.03 3.03 0 019 8a3.03 3.03 0 013 2.4.5.5 0 11-.98.2c0-.06-.35-1.6-2-1.6H9zM6.5 6.25a.75.75 0 100-1.5.75.75 0 000 1.5zM11.5 6.25a.75.75 0 100-1.5.75.75 0 000 1.5z"
                />
              </g>
            );
          case 2:
            return (
              <g clipPath="url(#clip0)">
                <path
                  style={{ stroke, fill, fillOpacity: 0.89 }}
                  d="M14.5 1H.5a.5.5 0 00-.49.6c.02.1.07.18.14.25L2 3.7v8.8A1.5 1.5 0 003.5 14h11a1.5 1.5 0 001.5-1.5v-10A1.5 1.5 0 0014.5 1zm-8 8h5a.5.5 0 010 1h-5a.5.5 0 010-1zm-.75-3.5a.75.75 0 111.5 0 .75.75 0 01-1.5 0zm5.75.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
                />
                <path
                  style={{ stroke, fill: '#fff' }}
                  d="M6.5 6.25a.75.75 0 100-1.5.75.75 0 000 1.5zM11.5 6.25a.75.75 0 100-1.5.75.75 0 000 1.5zM6.5 10h5a.5.5 0 000-1h-5a.5.5 0 100 1z"
                />
              </g>
            );
          case 3:
            return (
              <g clipPath="url(#clip0)">
                <path
                  style={{ stroke, fill, fillOpacity: 0.89 }}
                  d="M14.5 1H.5c-.2 0-.4.1-.45.3-.1.2-.05.4.1.55L2 3.7v8.8c0 .85.65 1.5 1.5 1.5h11c.85 0 1.5-.65 1.5-1.5v-10c0-.85-.65-1.5-1.5-1.5z"
                />
                <path
                  style={{ stroke, fill: '#fff' }}
                  d="M6.4 8c.25-.05.55.1.6.4.2.95 1.05 1.6 2 1.6s1.8-.65 2-1.6c.05-.3.3-.45.6-.4.3.05.45.3.4.6a3.06 3.06 0 01-3.65 2.35A3.06 3.06 0 016 8.6c-.05-.25.1-.55.4-.6zM6.5 6.25a.75.75 0 100-1.5.75.75 0 000 1.5zM11.5 6.25a.75.75 0 100-1.5.75.75 0 000 1.5z"
                />
              </g>
            );
          case 4:
            return (
              <g clipPath="url(#clip0)">
                <path
                  style={{ stroke, fill, fillOpacity: 0.89 }}
                  d="M14.5 1H.5c-.2 0-.4.1-.45.3-.1.2-.05.4.1.55L2 3.7v8.8c0 .85.65 1.5 1.5 1.5h11c.85 0 1.5-.65 1.5-1.5v-10c0-.85-.65-1.5-1.5-1.5z"
                />
                <path
                  style={{ stroke, fill: '#fff' }}
                  d="M7.5 4.25a.88.88 0 00-1.25 0L6 4.5l-.25-.25a.88.88 0 00-1.25 0 .88.88 0 000 1.25L6 7l1.5-1.5a.88.88 0 000-1.25zM12.25 4.25L12 4.5l-.25-.25a.88.88 0 00-1.25 0 .88.88 0 000 1.25L12 7l1.5-1.5a.88.88 0 000-1.25.88.88 0 00-1.25 0zM8.95 11c2 0 3-1.75 3-2.4 0-.15 0-.25-.1-.4a.45.45 0 00-.4-.2H6.5c-.15 0-.3.05-.4.2-.1.15-.1.25-.1.4C6 9.25 7 11 8.95 11z"
                />
              </g>
            );
          default:
            return null;
        }
      })()}
      <defs>
        <clipPath id="clip0">
          <path style={{ fill: '#fff' }} d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </Svg>
  );
}
